export default __webpack_public_path__ + "static/media/CV-VictorXirau.7bc94791.pdf";